import { render, staticRenderFns } from "./MalattieInfettiveStruttureViewComponent.vue?vue&type=template&id=53e7d588"
import script from "./MalattieInfettiveStruttureViewComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveStruttureViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports